import React from 'react';

import ExportPDFButton from './ExportPDFButton';
import DownloadUBLButton from './DownloadUBLButton';
import DownloadACKButton from './DownloadACKButton';
import ValidatePeppolButton from './ValidatePeppolButton';
import SendEmailButton from './SendEmailButton';
import SendPeppolButton from './SendPeppolButton';
import ReverseInvoiceButton from './ReverseInvoiceButton';
import PaidInvoiceButton from './PaidInvoiceButton';

const InvoiceActionsButtons = (props) => (
    <>
        <ExportPDFButton {...props} />
        <DownloadUBLButton {...props} />
        <DownloadACKButton {...props} />
        <ValidatePeppolButton {...props} />
        <SendEmailButton {...props} />
        <SendPeppolButton {...props} />
        <ReverseInvoiceButton {...props} />
        <PaidInvoiceButton {...props} />
    </>
);

export default InvoiceActionsButtons;